<template>
  <div class="ajuda">
    <div class="container">
      <h1 class="display-1 my-3">Ajuda</h1>
      <v-divider></v-divider>
      <!--p class="subtitle-2 grey--text my-3">
        Neste manual encontram-se instruções para o acesso a NFSe para utilização.
        Para visualização dos manuais, se faz necessário que esteja instalado em seu
        computador o Adobe Reader. caso não possua instalado,
        <a href="https://get.adobe.com/br/reader/" target="_blank">clique aqui</a>
        e siga as instruções de instalação.
      </p-->
      <!-- <v-btn class="my-2" small color="primary" @click="mostraPDF" outlined>
        <v-icon small left>exit_to_app</v-icon>
        <span>Baixar Manual</span>
      </v-btn>-->
      <!--v-btn
        class="my-2"
        small
        color="primary"
        outlined
        :href="linkManual"
        target="_blank"
      >
        <v-icon small left>exit_to_app</v-icon>
        <span>Baixar Manual</span>
      </v-btn-->

<!--      <v-divider></v-divider>-->

<!--      <v-layout class>-->
<!--        <v-row wrap>-->
<!--          <v-flex x12 lg12>-->
<!--            <h1 class="headline mt-5 ml-2">-->
<!--              Guias Rápidos <v-icon size="28px">feed</v-icon>-->
<!--            </h1>-->
<!--            <p class="subtitle-2 grey&#45;&#45;text my-3 ml-2">-->
<!--              Confira aqui de forma ilustrada, um guia rápido com as principais-->
<!--              funcionalidades e configurações iniciais para uso.-->
<!--              <strong>Clique nas imagens para melhor visualização</strong> .-->
<!--            </p>-->
<!--          </v-flex>-->
<!--          <v-flex>-->
<!--            <silent-box :gallery="galeria"></silent-box>-->
<!--          </v-flex>-->
<!--        </v-row>-->
<!--      </v-layout>-->

<!--      <v-divider></v-divider>-->

<!--      <v-layout>-->
<!--        <v-row wrap>-->
<!--          <v-flex x12 lg12>-->
<!--            <h1 class="headline mt-5 ml-2">-->
<!--              Vídeos Tutoriais <v-icon size="28px">videocam</v-icon>-->
<!--            </h1>-->
<!--            <p class="subtitle-2 grey&#45;&#45;text my-3 ml-2">-->
<!--              Confira aqui vídeos explicativos de como usar as principais-->
<!--              funcionalidades do sistema e suas particularidades.-->
<!--            </p>-->
<!--          </v-flex>-->
<!--        </v-row>-->
<!--      </v-layout>-->

<!--      <v-divider></v-divider>-->

<!--                <v-list-item-group color="primary">-->
<!--                  <v-list-item v-for="item in media" :key="item.id">-->
<!--                    <v-list-item-icon>-->
<!--                      <v-icon v-text="item.icon"></v-icon>-->
<!--                    </v-list-item-icon>-->
<!--                    <v-list-item-content>-->
<!--                      <v-list-item-title v-text="item.text"></v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                    <v-dialog width="780" v-model="item.show">-->
<!--                      <template v-slot:activator="{ on, attrs }">-->
<!--                        <v-btn-->
<!--                          color="primary"-->
<!--                          outlined-->
<!--                          small-->
<!--                          dark-->
<!--                          v-bind="attrs"-->
<!--                          v-on="on"-->
<!--                        >-->
<!--                          Ver-->
<!--                        </v-btn>-->
<!--                      </template>-->
<!--                      <v-card>-->
<!--                        <v-card-title class="text-h5 grey lighten-2">-->
<!--                          <p>{{ item.text }}</p>-->
<!--                        </v-card-title>-->

<!--                        <v-card-text>-->
<!--                          <video-->
<!--                            type="video/mp4"-->
<!--                            v-if="item.show"-->
<!--                            width="700"-->
<!--                            controls-->
<!--                            autoplay-->
<!--                            :src="item.url"-->
<!--                          ></video>-->
<!--                          &lt;!&ndash; <iframe-->
<!--                            v-if="item.show"-->
<!--                            width="750"-->
<!--                            height="600"-->
<!--                            :src="item.url"-->
<!--                            frameborder="0"-->
<!--                            allow=" autoplay"-->
<!--                            allowfullscreen-->
<!--                            controlsList="nodownload"-->
<!--                          ></iframe> &ndash;&gt;-->
<!--                        </v-card-text>-->

<!--                        <v-card-actions>-->
<!--                          <v-spacer></v-spacer>-->
<!--                          <v-btn color="primary" text @click="item.show = false">-->
<!--                            Fechar-->
<!--                          </v-btn>-->
<!--                        </v-card-actions>-->
<!--                      </v-card>-->
<!--                    </v-dialog>-->
<!--                  </v-list-item>-->
<!--                </v-list-item-group>-->
<!--              </v-list>-->
<!--            </v-card>-->
<!--          </v-flex>-->
<!--        </v-row>-->
<!--      </v-layout>-->

      <v-layout class="my-10">
        <v-row wrap>
          <v-flex xs12>
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title>Perguntas e Respostas</v-toolbar-title>
            </v-toolbar>
            <!-- <v-skeleton-loader
              v-if="loading"
              :transition="transition"
              type="table-row-divider"
            ></v-skeleton-loader>-->
            <FaqTabs :perguntas="perguntas" />
          </v-flex>
        </v-row>
      </v-layout>
    </div>
  </div>
</template>

<script>
import FaqTabs from '@/components/FaqTabs.vue';
import EventService from '../services/EventService';

export default {
  props: {
    perguntas: {
      type: Array,
    },
  },
  components: {
    FaqTabs,
  },
  data() {
    return {
      loading: true,
      transition: 'fade-transition',
      manuais: [],
      linkManual: '',
      decodeStr: '',
      galeria: [
        {
          src: 'guia/1Acesso.jpg',
          description: 'Como obter acesso para usar o sistema.',
          alt: 'Acesso a nota',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/2ConfiguracaoEmpresa.jpg',
          description: 'Configurando dados da empresa para emissão da nota.',
          alt: 'Configurar empresa',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/3ConfiguracaoNota.jpg',
          description: 'Configurando dados da nota para sua empresa.',
          alt: 'Configurar nota',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/4EmissaoGuia.jpg',
          description: 'Emitir guia para recolhimento.',
          alt: 'Emissão de guia de recolhimento',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/5EmissaoPrestador.jpg',
          description: 'Emitir nota para prestador de serviço.',
          alt: 'Nota prestador',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/6EmissaoTomador.jpg',
          description: 'Emitir nota tomador de serviço.',
          alt: 'Nota tomador',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/7ObrasMateriaisDedutiveis.jpg',
          description: 'Dedução de materiais em obras.',
          alt: 'Dedução de materiais',
          thumbnailWidth: '220px',
        },
        {
          src: 'guia/8ProcuracaoEletronica.jpg',
          description: 'Procuração eletrônica para emissão de notas.',
          alt: 'Procuração Eletrônica',
          thumbnailWidth: '220px',
        },
      ],
      media: [
        {
          id: 0,
          text: 'Acesso e recuperação de senha e e-mail',
          icon: 'password',
          show: false,
          url: 'videos/acesso.mp4',
        },
        {
          id: 1,
          text: 'Emissão de Nota Fiscal Prestador',
          icon: 'task',
          show: false,
          url: 'videos/emissaoPrestador.mp4',
        },
        {
          id: 2,
          text: 'Emissão de Nota Fiscal Tomador',
          icon: 'sticky_note_2',
          show: false,
          url: 'videos/emissaoTomador.mp4',
        },
        {
          id: 3,
          text: 'Emissão da Guia de Recolhimento',
          icon: 'request_page',
          show: false,
          url: 'videos/emissaoGuia.mp4',
        },
      ],
    };
  },
  methods: {
    mostraPDF() {
      let pdf = this.decodeStr;
      let dataURI = 'data:application/pdf;base64,' + pdf;
      // window.open(dataURI);
      let link = document.createElement('a');
      link.download = 'NFSeManual.pdf';
      link.href = dataURI;
      link.textContent = 'Baixar PDF';
      link.click();
      document.body.appendChild(link);
    },
  },
  created() {
    EventService.getConteudo().then(response => {
      // this.loading = false;
      // this.manuais = response.data.listaManual;
      // this.decodeStr = this.manuais[0].arquivo;
      // this.linkManual = this.manuais[0].url;
      // console.log(this.linkManual);
    });
  },
};
</script>

<style>
.silentbox-item {
  margin: 10px;
}
</style>
